import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Spinner from '../../../App/Components/Spinner/Spinner'
import { useAppDispatch, useAppSelector } from '../../../App/Hooks/reduxHooks'
import { Button } from '../../../Common/Button'
import { getUsers } from '../../../User/Store/actions'
import { IUserHr } from '../../../User/UsersHr/interfaces/IUserHr'
import { getHrUsers } from '../../../User/UsersHr/Store/Actions'
import { CreatePerson } from '../../CreatePerson/CreatePerson'
import { DeletePerson } from '../../DeletePerson/DeletePerson'
import { EditPerson } from '../../EditPerson/EditPerson'
import { getPunchclockTimes } from '../Store/Actions'
import { UserCard } from '../UserCard/UserCard'

import { ButtonWrapper } from './style'
import style from './style.scss'

export type PersonCrud =
  | { state: 'create'; person: null }
  | { state: 'edit'; person: IUserHr }
  | { state: 'delete'; person: IUserHr }

export const Overview = () => {
  const [personCrud, setPersonCrud] = useState<PersonCrud | null>(null)

  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const currentUser = useAppSelector(state => state.users.currentUser)
  const hrUsers = useAppSelector(state => state.hr.hrUsers)
  const establishment = useAppSelector(state => state.establishment.active)
  const isUsersLoading = useAppSelector(state => state.users.loading)

  const users = useAppSelector(state => {
    if (!state.users.list || !establishment) {
      return null
    }
    return state.users.list.filter(
      user => user.establishmentId === establishment.id,
    )
  })

  const hrUsersRequest = useAppSelector(state => {
    if (!hrUsers.list || !state.establishment.active) {
      return null
    }
    const activeId = state.establishment.active.id
    return hrUsers.list.filter(user => user.establishmentId === activeId)
  })

  const loadPunchclockTimes = useAppSelector(
    state =>
      false === state.punchclock.isLoading &&
      typeof state.punchclock.times === 'undefined' &&
      false === state.punchclock.error,
  )

  if (loadPunchclockTimes) {
    dispatch(getPunchclockTimes())
  }

  if (!users && !isUsersLoading) {
    dispatch(getUsers())
    return <Spinner />
  }

  if (typeof hrUsers.list === 'undefined' && !hrUsers.loading) {
    dispatch(getHrUsers())
    return <Spinner />
  }

  if (!currentUser) {
    return <Spinner />
  }
  const canManagePunchClock = currentUser.permissions?.hrPunchClockManage

  const renderPersonCrud = () => {
    if (!personCrud) {
      return null
    }

    switch (personCrud.state) {
      case 'create':
        return <CreatePerson setPersonCrud={setPersonCrud} />
      case 'edit':
        return (
          <EditPerson
            selectedPerson={personCrud.person}
            setPersonCrud={setPersonCrud}
          />
        )
      case 'delete':
        return (
          <DeletePerson
            selectedPerson={personCrud.person}
            setPersonCrud={setPersonCrud}
          />
        )
    }
  }

  return (
    <div className={'page-layout large'}>
      <ButtonWrapper>
        {establishment &&
        establishment.permissions.includes('punchclock') &&
        canManagePunchClock ? (
          <a
            href="/punchclock/manage"
            className="button margin-bottom-large"
            style={{ display: 'flex', alignItems: 'center' }}>
            {t('Manage')}
          </a>
        ) : null}

        <Button
          className="button margin-bottom-large"
          onClick={() => setPersonCrud({ state: 'create', person: null })}>
          {t('Create')}
        </Button>
      </ButtonWrapper>
      {renderPersonCrud()}
      <div className={style.cardContainer}>
        {hrUsersRequest &&
          hrUsersRequest
            .filter(user => !user.isCabine)
            .map(user => {
              return (
                <UserCard
                  key={`user${user.uuid}`}
                  currentLoggedUser={currentUser}
                  user={user}
                  setPersonCrud={setPersonCrud}
                />
              )
            })}
      </div>
    </div>
  )
}
